import {hitGoogleTagManager} from "../../tracking/google_tag_manager/hit_google_tag_manager";

export const gtmRegistrationMultileadView = (totalOffers: number, buttonText: string) => {
    hitGoogleTagManager({
        event: "modal_post_price_reveal_multilead",
        event_action: "view",
        event_label: buttonText,
        custom_label: String(totalOffers)
    });
};

export const gtmRegistrationMultileadClick = (selectedCount: number, totalOffers: number, buttonText: string) => {
    hitGoogleTagManager({
        event: "modal_post_price_reveal_multilead",
        event_action: "click",
        event_label: buttonText,
        custom_label: `${selectedCount} z ${totalOffers}`
    });
};

export const gtmRegistrationMultileadClose = (totalOffers: number) => {
    hitGoogleTagManager({
        event: "modal_post_price_reveal_multilead",
        event_action: "close",
        custom_label: String(totalOffers)
    });
};
import {hitGoogleTagManager} from "../../tracking/google_tag_manager/hit_google_tag_manager";

export const gtmRegistrationMultileadView = (totalOffers: number, buttonText: string) => {
    hitGoogleTagManager({
        event: "modal_post_price_reveal_multilead",
        event_action: "view",
        event_label: buttonText,
        custom_label: String(totalOffers)
    });
};

export const gtmRegistrationMultileadClick = (selectedCount: number, totalOffers: number, buttonText: string) => {
    hitGoogleTagManager({
        event: "modal_post_price_reveal_multilead",
        event_action: "click",
        event_label: buttonText,
        custom_label: `${selectedCount} z ${totalOffers}`
    });
};

export const gtmRegistrationMultileadClose = (totalOffers: number) => {
    hitGoogleTagManager({
        event: "modal_post_price_reveal_multilead",
        event_action: "close",
        custom_label: String(totalOffers)
    });
};
